import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useUserEventLogger } from '@repo/tracking-service';
import { BoxButton, Description, Drawer, DrawerContent, DrawerFooter, DrawerHeader, LottiePlayer, IconButton } from '@repo/ui';
import { differenceInDays } from 'date-fns';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const BZNAV_MARKETING_NOTI_LATER = 'bznav_marketing_noti_later';

export const MarketingNotificationModal = NiceModal.create(() => {
  const { visible, hide, remove } = useModal();
  const router = useRouter();
  const { sendViewEvent, sendClickEvent } = useUserEventLogger();

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      hide();
    }
  };

  const handleClose = () => {
    remove();
  };

  const acceptanceNotification = () => {
    sendClickEvent('home_modal_get-noti');
    router.push({ pathname: '/my/notification', query: router.query });
    hide();
  };

  const handleClickLater = () => {
    sendClickEvent('home_modal_later');
    localStorage.setItem(BZNAV_MARKETING_NOTI_LATER, new Date().toDateString());
    hide();
  };

  useEffect(() => {
    if (visible) {
      sendViewEvent('home_modal_marketing');
    }
  }, [visible, sendViewEvent]);

  return (
    <Drawer open={visible} onOpenChange={handleOpenChange} onClose={handleClose} dismissible={false}>
      <DrawerContent>
        <DrawerHeader className={'flex justify-end items-center'}>
          <IconButton iconType={'close'} onClick={hide} />
        </DrawerHeader>
        <Description
          graphic={
            <div className={'h-20 w-20'}>
              <LottiePlayer src={'/lotties/alarm-lottie.json'} />
            </div>
          }
          title={'가장 빠르게 환급 혜택 · 이벤트\n소식을 받아보시겠어요?'}
          description={'지금 마케팅 알림받기를 설정하고\n다양한 혜택을 놓치지 않고 받아보세요.'}
        />
        <DrawerFooter className={'container container-padding-medium container-medium pb-normal-medium'}>
          <div className={'flex w-full gap-normal-small'}>
            <BoxButton variant={'tonal-secondary'} size={'large'} className={'w-full'} onClick={handleClickLater}>
              나중에
            </BoxButton>
            <BoxButton size={'large'} className={'w-full'} onClick={acceptanceNotification}>
              알림받기 설정
            </BoxButton>
          </div>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
});

export function useCloseAfterTwoWeeks() {
  const timestamp = localStorage.getItem(BZNAV_MARKETING_NOTI_LATER);
  const alreadyLaterClickAfterTwoWeeks = !!timestamp && differenceInDays(new Date(), timestamp) > 14;

  return !timestamp || alreadyLaterClickAfterTwoWeeks;
}
